import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class Profile extends Mixins(CommonView) {
    pnkzList: {name: string, path: string | null}[] = [];
    url: string = "";
    isDelivery: boolean = false;

    mode: number = -1;
    kurukuru: boolean = false;
    error: string = "";
    user: BASEAPI.User = BASEAPI.user();

    element: HTMLElement = <HTMLElement>document.scrollingElement;

    public async created() {
        await this.init();
    }

    @Watch('$route')
    public async init() {
        if (await this.isLoginRedirect(true)) return;

        if (this.$route.query && this.$route.query.url && typeof this.$route.query.url === "string") {
            this.url = this.$route.query.url;
            if (this.$route.query.hash && typeof this.$route.query.hash === "string"){
                this.url += "#" + this.$route.query.hash;
            }
        } else {
            this.url = "";
        }

        let response = await BASEAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
        } else {
            response.data.email = "";
            this.user = response.data;
        }

        let query = this.$route.query;
        if (query.page === "url") {
            this.mode = 0;
        }

        this.pnkzList = [
            {name: "TOP", path: "/"},
            {name: "マイページ", path: "/mypage"},
            {name: "会員情報確認・編集", path: null}
        ];
    }

    public async edit() {
        this.mode = 0
    }

    public async check() {
        //バリデーションチェック
        if (!(this.user.name.match(/^[\u30a0-\u30ff\u3040-\u309f\u3005-\u3006\u30e0-\u9fcf]+$/) || this.user.name.match(/^[0-9a-zA-Z]*$/) || this.user.name.match(/[\x20\u3000]/))) {
            this.error = "「名前」は、漢字・カタカナ・ひらがな・半角英数字で入力してください。";
            this.element.scrollTop = 0;
            return;
        }
        if (this.getByteLength1() > 32) {
            this.error = "「住所」は32文字（半角32文字・全角16文字）以内で入力してください。";
            this.element.scrollTop = 0;
            return;
        }
        if (this.user.address.indexOf(',' ) !== -1 || this.user.address2.indexOf(',' ) !== -1) {
            this.error = "「住所」にはカンマ「,」は使用できません。";
            this.element.scrollTop = 0;
            return;
        }

        if (this.user.address.indexOf('都') == -1 && this.user.address.indexOf('道') == -1 && this.user.address.indexOf('府') == -1 && this.user.address.indexOf('県') == -1) {
            this.error = "「住所」には都道府県を必ず記入してください。";
            this.element.scrollTop = 0;
            return;
        }

        if (this.user.address2.indexOf('−') !== -1) {
            this.error = "「住所2」にはマイナス「−」は使用できません。半角ハイフン「-」または全角「ー」をご利用ください。";
            this.element.scrollTop = 0;
            return;
        }

        this.mode = 1;
    }

    public async back() {
        let response = await BASEAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
        } else {
            response.data.email = "";
            this.user = response.data;
        }

        this.mode = -1;
    }

    public async put() {
        this.kurukuru = true;
        this.error = "";
        let res = await BASEAPI.UserController.putUserUsingPUT(this.user).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
            this.mode = 0;
            this.element.scrollTop = 0;
        } else {
            this.mode = 2;
        }
        this.kurukuru = false;
    }

    // バイト数を取得する関数
    public getByteLength1() {
        let count = 0;
        for (let i = 0; i < this.user.address.length; i++) {
            const charCode = this.user.address.charCodeAt(i);
            if (charCode <= 255) {
                count += 1; // 半角文字は1バイト
            } else {
                count += 2; // 全角文字は2バイト
            }
        }
        return count;
    }

    // バイト数を取得する関数
    public getByteLength2() {
        let count = 0;
        for (let i = 0; i < this.user.address2.length; i++) {
            const charCode = this.user.address2.charCodeAt(i);
            if (charCode <= 255) {
                count += 1; // 半角文字は1バイト
            } else {
                count += 2; // 全角文字は2バイト
            }
        }
        return count;
    }
}
